module.exports = __webpack_public_path__ + "img/collection-diamondJewelryExclusive.3db1835.webp";